import React from 'react';

import classNames from 'classnames';
import { Kbd } from '@ergeon/help-components';

import { KeyboardHint } from './keyboard';

type KeyboardHintsProps = {
  className?: string;
  hints: KeyboardHint[];
};

const KeyboardHints = ({ className, hints }: KeyboardHintsProps) => (
  <dl className={classNames('flex flex-col gap-2 paragraph-2', className)}>
    {hints.map(({ keys, label }) => (
      <div className="flex items-center justify-between gap-3" key={label}>
        <dt className="text-gray-700 dark:text-gray-300">{label}</dt>
        <dd className="flex shrink-0 items-center gap-1">
          {keys.map((key) => <Kbd key={key}>{key}</Kbd>)}
        </dd>
      </div>
    ))}
  </dl>
);

export default KeyboardHints;
